export const ESG_ROW_KEYS = {
    idx: "idx",
    question: "question",
    maxPossibleScore: "maxScore",
    selfValue: "self-value",
    selfScore: "self-score",
    adminScore: "admin-score",
    numExternalAnswers: "external-answers",
    externalAverage: "external-average",
    finalScore: "final-score",
    next: "next",
    weight: "weight",
    area: "area",
    nextAnswerLabel: "nextAnswerLabel",
};

export const ESG_TABLE_COLUMNS = [
    { key: ESG_ROW_KEYS.idx, label: "" },
    ESG_ROW_KEYS.question,
    { key: ESG_ROW_KEYS.selfScore, label: "Your answer" },
    {
        key: ESG_ROW_KEYS.finalScore,
        label: "Score",
        _style: { width: "15%" },
    },
    {
        key: ESG_ROW_KEYS.next,
        label: "What's next?",
    },
];

export const PRINT_ESG_TABLE_COLUMNS = [
    { key: ESG_ROW_KEYS.idx, label: "" },
    ESG_ROW_KEYS.question,
    { key: ESG_ROW_KEYS.selfScore, label: "Your answer" },
    {
        key: ESG_ROW_KEYS.finalScore,
        label: "Score",
    },
];

export const ESG_EXTERNAL_COLUMNS = [
    { key: [ESG_ROW_KEYS.idx], label: "" },
    ESG_ROW_KEYS.question,
    { key: ESG_ROW_KEYS.numExternalAnswers, label: "Number of answers" },
    { key: ESG_ROW_KEYS.externalAverage, label: "Average answer" },
];

export const ESG_EDIT_COLUMNS = [
    { key: [ESG_ROW_KEYS.idx], label: "" },
    ESG_ROW_KEYS.question,
    ESG_ROW_KEYS.weight,
    "edit"]


export const ESG_INTERNAL_COLUMNS = [
    { key: [ESG_ROW_KEYS.idx], label: "" },
    ESG_ROW_KEYS.question,
    { key: ESG_ROW_KEYS.selfScore, label: "User answer" },
    { key: ESG_ROW_KEYS.adminScore, label: "Admin score" },
];
